require './reinforce'
mate = require('./coffee-mate')
global[k] = v for k, v of mate
